'use strict';

/*
DOCUMENT ME
*/

define('modules/module.offer.specific',[
  'jquery',
  './module',
  'txt!./module.offer.hbs',
  'txt!./module.static.hbs',
  'txt!./module.loader.hbs',
  'lib/page-cache',
  'lib/services/offers-service',
  'lib/transforms/offers.tmpl.common',
  'lib/util/zip',
  'lib/util/tda.config',
  'features/favorites',
  './module.offer.generic',
  'zipTools'
], function (
  $,
  Module,
  txtTemplate,
  txtStatic,
  txtModuleLoader,
  PageCache,
  offersServiceFactory,
  xformOffersCommon,
  zip,
  tdaConfig,
  favorites,
  OfferGenericModule,
  zipTools
) {
  var offersService = offersServiceFactory(tdaConfig.offers.r2_api_key);

  var __tmplBody = Handlebars.compile(txtTemplate);
  var __tmplLoader = Handlebars.compile(txtModuleLoader);
  var __tmplStatic = Handlebars.compile(txtStatic);

  var OfferSpecificModule = Module.extend({
    template: __tmplLoader,
    events: function () {
      return Object.assign({}, Module.prototype.events, {
        'click .module-cta-0': 'onViewClicked',
        'click .img-cont': 'onViewClicked',
        'click .favorite-button': 'onFavClicked'
      });
    },

    staticData: {
      all: {},
      en: {
        actions: [
          {
            title: 'View Offer',
            url: '/' + tdaConfig.site.context_url + '/offer-detail/'
          }
        ],
        copyMore: {
          bonusCash: 'Bonus Cash',
          multipleVehicles: 'Multiple Vehicles',
          dueAtSigning: 'Due at Signing',
          months: 'Months',
          perMonth: 'Per Month'
        },
        dataLayerMore: {
          link_text: 'favorite_button'
        }
      },
      es: {
        actions: [
          {
            title: 'Ver cuánto vale',
            url: '/' + tdaConfig.site.context_url + '/offer-detail/',
          }
        ],
        copyMore: {
          bonusCash: 'Bono en efectivo',
          multipleVehicles: 'Multiple Vehicles',
          dueAtSigning: 'A Pagar al Firmar',
          months: 'Meses',
          perMonth: 'al Mes'
        },
        dataLayerMore: {
          link_text: 'favorite_button'
        }
      }
    },

    initialize: function (canvas, config, idx) {
      // Call the supers initialize
      Module.prototype.initialize.apply(this, arguments);

      // Load the offer if we have an offer id
      if (config.data && config.data.offerId) {
        this.loadOffer(config.data.offerId.replace('_es', ''));
      }
    },

    loadOffer: function (offerId) {
      var self = this;
      var cacheId = 'offer.' + offerId;

      // Await the eventual offer response value
      PageCache.await(cacheId)
        .then(function (res) {
          return xformOffersCommon(res.offerBundle.offers);
        })
        .then(function (offers) {
          if ( offers.length ) {
            self.offer = offers[0];
            self.setTemplate(__tmplBody);
            self.markFav();
            self.updateModuleDataLayer();
          } else {
            self.offer = '';
            self.staticData = OfferGenericModule.staticData;
            self.drawExpired();
          }
        })
        .catch(function (err) { console.log('error in offer: ', err); });

      // If we don't already have a pending request or current value, fetch it
      if (!PageCache.has(cacheId) && !PageCache.isPending(cacheId)) {
        var request = {
          tdaCode: tdaConfig.tda.code,
          zipCode: zip.getCookiedDefaultFallback(),
          offerId: offerId,
          lang: this.getCanvas().getLang()
        };
        PageCache.maybeSet(cacheId, offersService.offers().byOfferId(request));
      }
    },

    getTemplateContext: function () {
      var ctx = $.extend({}, this.staticData.all, this.staticData[this.getCanvas().getLang()], this.getConfig().data);
      ctx.offer = this.offer;
      return ctx;
    },

    drawExpired: function () {
      this.setTemplate(__tmplStatic);
      this.markExpired();
    },

    markExpired: function () {
      $(this.$el)
        .removeClass('module-offer-specific')
        .addClass('module-offer-generic module-offer-specific-expired');
    },

    resize: function () {
      Module.prototype.resize.apply(this, arguments);
      this.markFav();
      if (this.offer === '') {
        this.markExpired();
      }
    },

    markFav: function () {
      var favButton = $(this.$el).find('.favorite-button');
      favorites.markFav(favButton);
    },

    onFavClicked: function (e) {
      e && e.preventDefault();
      var $target = $(e.currentTarget);
      // seems a bit much to me, to pass in the ENTIRE target?
      favorites.addRemove($target);
    },

    onViewClicked: function (e) {
      // handle via JS since other elements need this event too
      e && e.preventDefault();
      if (tdaConfig.tda.code === 'WWW') {
        // If we are on WWW, show the zip dialog
        zipTools.promptUserForZip(zip.getCookiedDefaultFallback(), $(e.currentTarget).attr('href'));
      } else {
        window.location = $('.module-cta-0', this.$el).attr('href');
      }
    },

    // there's a default dataLayer output on parent .module
    // take that and supplement it with our offer data.
    updateModuleDataLayer: function () {
      var $parent = this.$el;
      var dataToAdd = this.offer.dataLayer;
      var data = $parent.data('layer') || {};
      if (typeof data !== 'object') {
        data = JSON.parse(data);
      }
      // update data on parent module
      var fullData = Object.assign({}, data, dataToAdd);
      $parent.data('layer', fullData);
    },
  });

  return OfferSpecificModule;
});

